import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { AppRoutingModule } from '../../../app-routing.module';
import { Angular2SocialLoginModule } from 'angular2-social-login';
import { BrowserModule } from '@angular/platform-browser';
import { ScriptHackModule } from '../script-hack/script-hack.module';
import { GoogleCustomerReviewsComponent } from './google-customer-reviews.component';

@NgModule({
    declarations: [
        GoogleCustomerReviewsComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        HttpModule,
        HttpClientModule,
        Angular2SocialLoginModule,
        AppRoutingModule,
        ScriptHackModule
    ],
    providers: [],
    bootstrap: [],
    exports: [
        GoogleCustomerReviewsComponent
    ]
})
export class GoogleCustomerReviewsModule {}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/shared/components/google-customer-reviews/google-customer-reviews.module.ts